<div
  class="campaign-page-container text-[--text]"
  *ngIf="campaignPage && showPage">
  <div class="promo-period-container">
    <div class="promo-period-heading">
      <h1 class="mt-0">{{ campaignPage.mainHeading }}</h1>
      <h2 class="mt-0">{{ campaignPage.subHeading }}</h2>
    </div>
    <div
      class="promo-period-widget"
      *ngIf="
        campaignPage.promoPeriod &&
        campaignPage.promoPeriodHeading &&
        campaignPage.promoPeriodIcon
      ">
      <div class="promo-period-image"></div>
      <div class="promo-period-value">
        <img class="promo-icon" [src]="campaignPage.promoPeriodIcon" alt="" />
        <div class="promo-period-text">
          <h3 class="my-0">{{ campaignPage.promoPeriodHeading }}</h3>
          <span class="value" [innerHTML]="campaignPage.promoPeriod"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="main-container">
    <img
      *ngIf="campaignPage.heroImageUrlDesktop"
      class="hero-desktop-image"
      [src]="campaignPage.heroImageUrlDesktop"
      alt="" />
    <img
      *ngIf="campaignPage.heroImageUrlMobile"
      class="hero-mobile-image"
      [src]="campaignPage.heroImageUrlMobile"
      alt="" />

    <h2
      class="main-description-heading mt-0"
      *ngIf="campaignPage.mainDescriptionHeading">
      {{ campaignPage.mainDescriptionHeading }}
    </h2>
    <div
      class="hero-description mb-6 py-4"
      [innerHTML]="campaignPage.heroImageDescription"></div>

    <h2
      class="mt-0text-xl mb-6 text-[--primary-400] lg:text-2xl"
      *ngIf="campaignPage.campaignPageBannersHeading">
      {{ campaignPage.campaignPageBannersHeading }}
    </h2>
    <div
      class="campaign-page-banner-section grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-9">
      <ng-container
        *ngFor="let campaignPageBanner of campaignPage.campaignPageBanners">
        <div class="">
          <img
            class="desktop-image"
            [src]="campaignPageBanner.campaignPageBannerUrlDesktop"
            alt="" />
          <img
            class="mobile-image"
            [src]="campaignPageBanner.campaignPageBannerUrlMobile"
            alt="" />
          <h3
            class="main-content"
            [innerHTML]="campaignPageBanner.campaignPageBannerTitle"></h3>
          <p
            class="sub-content"
            [innerHTML]="campaignPageBanner.campaignPageBannerDescription"></p>
          <p
            class="link"
            [innerHTML]="campaignPageBanner.campaignPageBannerActionLink"></p>
        </div>
      </ng-container>
    </div>

    <div
      class="mt-6 py-4"
      *ngFor="let campaignPageContent of campaignPage.contentBlocks">
      <h2
        class="mb-6 mt-0 text-xl text-[--primary-400] lg:text-2xl"
        *ngIf="campaignPageContent.campaignPageBlockTitle">
        {{ campaignPageContent.campaignPageBlockTitle }}
      </h2>
      <div [innerHTML]="campaignPageContent.campaignPageBlockBody"></div>
      <div class="mt-4">
        <img
          class="hidden lg:block"
          [src]="campaignPageContent.campaignPageBlockImageUrlDesktop"
          alt="" />
        <img
          class="block w-full lg:hidden"
          [src]="campaignPageContent.campaignPageBlockImageUrlMobile"
          alt="" />
      </div>
    </div>
  </div>
</div>
